import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track2ARed = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED);
	return (
		<g id="Track2ARed" transform="translate(1069.000000, 691.000000)" className="track">
			<path
				d="M75,38 C75,38 75,38 75,38 C85.1928276,41.2405438 94.5153695,46.7563618 102.262604,54.1303175 L213.438573,159.949589 C219.229478,165.461477 225.660472,170.259036 232.593817,174.239516 L275.722528,199 L275.722528,199"
				id="line" stroke={trackColor}
				strokeWidth={tracksWidth} strokeLinecap="round"/>

			<g id="line"
				 transform="translate(36.263087, 23.609233) rotate(24.000000) translate(-36.263087, -23.609233) translate(1.763087, 13.609233)"
				 stroke={trackColor} strokeLinecap="round"
				 strokeWidth={tracksWidth}
			>
				<line x1="65.6634" y1="8.4269" x2="0.917632189" y2="18.8117632"/>
				<TrackArrow transform="translate(63.151691, 8.617555) rotate(-189.000000) translate(-63.151691, -8.617555) "
										points="67.1516914 16.6175553 59.1516914 8.61755532 67.1516914 0.617555324"/>
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track2ARed')}
				coords="82.941960, 34.255820"
				text="2A"
				textCoordsX="10.4370117"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			/>
		</g>
	)

};

Track2ARed.propTypes = trackPropTypes;

export default Track2ARed;
